export default value =>
  value.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });
